<template>
  <el-card
    shadow="never"
    class="aui-card--fill"
    style="font-family: 'fontStyle';"
  >
    <div class="mod-sys__dept">
      <search-condition
        :condition="searchConditionList"
        :formData="queryParams"
        labelWidth="70px"
        size="small"
        @search="handleQuery"
        @reset="resetQuery"
      >
      </search-condition>
      <div class="tableTop">
        <div class="left">
          <!-- 数据库更新时间：{{ tableDate }} -->
          Updated time：{{ tableDate }}
        </div>
        <div class="right">
          <!-- Rescan -->
          <!--  重新扫描 -->
          <el-button
            type="primary"
            @click="RESCAN"
            style="background: #304156;border-color:#304156;font-family: 'fontStyle';"
            >RESCAN</el-button
          >
        </div>
      </div>
      <!--   -->
      <!-- / -->
      <el-table
        class="tablebox-el"
        ref="tableList"
        v-loading="dataListLoading"
        :data="tableList"
        border
        style="width: 100%;"
        :default-sort="defaultsort"
        @sort-change="dataListSortChangeHandle"
        @header-click="dataListHeaderClickHandle"
      >
        >
        <!--  (公司股票代码名称) -->
        <el-table-column
          prop="ticker"
          :label="'TICKER'"
          sortable="custom"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div
              @click="handleTwoView(scope.row)"
              style="color: #00a4fa;cursor: pointer;"
            >
              {{ scope.row.ticker }}
            </div>
            <!-- <el-button type="primary" @click="handleTwoView(scope.row)" style="background: #304156;border-color:#304156">
              {{ scope.row.ticker }}</el-button> -->
          </template>
        </el-table-column>
        <!-- SECTOR (原SEGMENT，字段不变) -->
        <el-table-column
          prop="category"
          :label="'SECTOR'"
          sortable="custom"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.category }}
            </div>
          </template>
        </el-table-column>

        <!-- DURATION（存于duration字段，excel B21） -->
        <el-table-column
          prop="duration"
          :label="'DURATION'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.duration || scope.row.duration == 0">
                {{ formatNegative(scope.row.duration) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- R/R（riskReward字段，excel F21） -->
        <el-table-column
          prop="riskReward"
          :label="'R/R'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot="header">
            <span>R/R</span>
            <el-tooltip
              placement="top"
              content="R/R = (IRR – 10%) / (10% – Bear IRR) x (25% / Bear Weight)"
            >
              <i
                class="el-icon-question"
                style="margin-left: 4px; cursor: pointer;"
                @click.stop
              ></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.riskReward || scope.row.riskReward == 0">
                {{ formatNegative(scope.row.riskReward) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- QS（qs字段，excel K21） -->
        <el-table-column
          prop="qs"
          :label="'QS'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.qs || scope.row.qs == 0">
                {{ formatNegative(scope.row.qs) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- IRR（存于irr字段，excel G21） -->
        <el-table-column
          prop="irr"
          :label="'IRR'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.irr || scope.row.irr == 0">
                {{ formatNegative(scope.row.irr) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- QS ADJ IRR（存于qsAdjIrr字段，excel I21，默认排序列） -->
        <el-table-column
          prop="qsAdjIrr"
          :label="'QS ADJ IRR'"
          sortable="custom"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.qsAdjIrr || scope.row.qsAdjIrr == 0">
                {{ formatNegative(scope.row.qsAdjIrr) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- BEAR IRR（bearIrr字段，excel K19） -->
        <el-table-column
          prop="bearIrr"
          :label="'BEAR IRR'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.bearIrr || scope.row.bearIrr == 0">
                {{ formatNegative(scope.row.bearIrr) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- BEAR WEIGHT（存于bearWeight字段，excel L19） -->
        <el-table-column
          prop="bearWeight"
          :label="'BEAR WEIGHT'"
          sortable="custom"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.bearWeight || scope.row.bearWeight == 0">
                {{ formatNegative(scope.row.bearWeight) }}
              </span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!-- （操作者姓名） -->
        <el-table-column
          prop="analyst"
          :label="'ANALYST'"
          sortable="custom"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <!-- （访问文件链接） -->
        <el-table-column
          prop="root"
          :label="'PB'"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <div
              @click="handleView(scope.row)"
              style="color: #00a4fa;cursor: pointer;"
            >
              <!-- 原始PB -->
              <img
                class="imageExcel"
                src="../../../assets/img/excel.png"
                mode=""
              />
            </div>
            <!-- <el-button type="primary" @click="handleView(scope.row)" style="background: #304156;border-color:#304156"> {{
              scope.row.ticker }}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="queryParams.page"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="queryParams.limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
    <ViewInfo
      v-if="viewVisible"
      :open="viewVisible"
      ref="ViewInfo"
      title="View"
      :form="form"
      :deptList="deptList"
      @cancelOpen="changeViewVisible"
    />
  </el-card>
</template>

<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { getDictDataList } from "@/utils";
import ViewInfo from "./viewPage.vue";

export default {
  components: {
    ViewInfo,
  },
  data() {
    let self = this;
    return {
      scale: scale,
      multiple: true,
      viewVisible: false,
      single: true,
      total: 0,
      addOrUpdateVisible: false,
      tableList: [],
      queryParams: {
        orderFields: "qsAdjIrr",
        orderWay: "desc",
        page: 1,
        limit: 30,
      },
      //查询条件
      searchConditionList: [
        {
          key: "ticker",
          label: "TICKER",
          type: "input",
          initValue: "",
        },
        {
          key: "analyst",
          label: "ANALYST",
          type: "input",
          initValue: "",
        },
      ],
      statusOptions: getDictDataList("sys_content_status"),
      sectionList: [], //栏目数据
      deptList: [],
      form: {}, //获取部门
      dataListLoading: false,
      tableDate: "",
      formurl: "",
      defaultsort: { prop: "qsAdjIrr", order: "descending" },
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.getList();
    this.getdateList();
  },
  methods: {
    //负数显示为括号形式：-6% => (6%)
    formatNegative(val) {
      if (val && typeof val == "string") {
        var v = val.trim();
        if (v.length > 1 && v.charAt(0) == "-") {
          return "(" + v.substring(1) + ")";
        }
      }
      return val;
    },
    //获取数据
    getList() {
      this.dataListLoading = true;
      var that = this;
      this.$http
        .get("/sys/sysstock/page", { params: { ...this.queryParams } })
        .then((res) => {
          that.tableList = res.data.data.list;
          that.total = res.data.data.total;
          that.dataListLoading = false;
        })
        .catch((err) => {
          that.dataListLoading = false;
        });
    },
    //获取最新同步时间
    getdateList() {
      var that = this;

      this.$http
        .get("/sys/sysstock/getSyncTime")
        .then((res) => {
          that.tableDate = res.data.data;
        })
        .catch((err) => {
          that.dataListLoading = false;
        });
    },
    // 查看
    handleView(row) {
      this.form = row;
      this.form.deptName = this.getDepName(row.deptId);
      // this.getformurl(row)
      this.viewVisible = true;

      // this.$router.push({
      //   path: "/viewPage",
      //   params: { id: row.id },
      //   query: { id: row.id },
      // });
      // this.$refs.ViewInfo.into(row)
      // window.open('https://docs.google.com/viewer?url=' + 'http://59.110.159.111/gpweb/HK.xlsx', '_blank')
      // 'http://59.110.159.111/gpweb/HK.xlsx'
    },

    // 对比结果
    handleTwoView(row) {
      this.form = row;
      this.form.deptName = this.getDepName(row.deptId);

      this.$router.push({
        path: "/twoTable",
        params: { id: row.id },
        query: { id: row.id },
      });
    },

    //删除
    handleDelete(row) {
      let ids = row.id ? [row.id] : this.ids;
      this.$confirm(
        this.$t("prompt.info", { handle: this.$t("delete") }),
        this.$t("prompt.title"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .delete(`/sys/sysleavemessage`, { data: ids })
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  let { page, limit } = this.queryParams;
                  let totalPage = Math.ceil((this.total - ids.length) / limit);
                  let currentPage = page > totalPage ? totalPage : page;
                  this.queryParams.page = currentPage < 1 ? 1 : currentPage;
                  this.getList();
                },
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleQuery() {
      this.queryParams = {
        ...this.queryParams,
        page: 1,
      };
      console.log("queryParams", this.queryParams);
      this.getList();
    },
    resetQuery() {
      // var limit = this.queryParams.limit;
      this.queryParams = this.$options.data().queryParams;
      // this.queryParams.limit = limit;
      // this.defaultsort = { prop: 'qsAdjIrr', order: 'descending' }
      // this.dataListSortChangeHandle({ prop: 'qsAdjIrr', order: 'descending' })
      this.$refs.tableList.sort("qsAdjIrr", "descending");

      // this.$set()
      this.getList();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    //获取depName
    getDepName(id) {
      let name = "";
      const loop = (array) => {
        if (name) return;
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          if (element.id == id) {
            name = element.name;
          }
          if (element.children) {
            loop(element.children);
          }
        }
      };
      loop(this.deptList);
      return name;
    },
    // 重新扫描
    RESCAN() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$http
        .get("/sys/sysstock/syncExcelData")
        .then((res) => {
          if (res.data.code == 0 && res.data.msg == "success") {
            this.$message({
              message: "Data update successful!",
              type: "success",
              duration: 2000,
            });
            this.getList();
            this.getdateList();
            loading.close();
          } else {
            this.$message({
              message: "数据失败，请重新刷新！",
              type: "error",
              duration: 2000,
            });
            this.getList();
            this.getdateList();
            loading.close();
          }
        })
        .catch((err) => {
          loading.close();
          this.dataListLoading = false;
        });
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.queryParams.page = 1;
      this.queryParams.limit = val;
      this.getList();
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.queryParams.page = val;
      this.getList();
    },

    // 排序
    dataListSortChangeHandle(data) {
      if (this.scale < 1.8) {
        return;
      }

      if (data.prop == "qsAdjIrr") {
        this.queryParams.orderFields = "qsAdjIrr";
      }
      if (data.prop == "bearWeight") {
        this.queryParams.orderFields = "bearWeight";
      }
      if (data.prop == "irr") {
        this.queryParams.orderFields = "irr";
      }
      if (data.prop == "duration") {
        this.queryParams.orderFields = "duration";
      }
      // xinzneg
      if (data.prop == "qs") {
        this.queryParams.orderFields = "qs";
      }
      if (data.prop == "bearIrr") {
        this.queryParams.orderFields = "bearIrr";
      }
      if (data.prop == "riskReward") {
        this.queryParams.orderFields = "riskReward";
      }
      if (data.prop == "analyst") {
        this.queryParams.orderFields = "analyst";
      }
      if (data.prop == "ticker") {
        this.queryParams.orderFields = "ticker";
      }

      // xinznegjieshu
      if (data.prop == "category") {
        this.queryParams.orderFields = "category";
      }
      this.queryParams.orderWay =
        data.order == "ascending"
          ? "asc"
          : data.order == "" || data.order == null
          ? null
          : "desc";

      // if(this.queryParams.orderWay){
      //    this.queryParams.orderWay = asc
      // }

      this.getList();
    },
    dataListHeaderClickHandle(data) {
      if (this.scale >= 1.8) {
        return;
      }
      console.log("123456", data);
      var orderWay = "";
      if (data.order == null || data.order == "") {
        orderWay = "asc";
      } else if (data.order == "ascending") {
        orderWay = "desc";
      } else {
        orderWay = null;
      }
      // (data.order == "desc" ? null : (data.order == "asc" ? "desc" : "asc"));
      if (data.property == "qsAdjIrr") {
        this.queryParams.orderFields = "qsAdjIrr";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "bearWeight") {
        this.queryParams.orderFields = "bearWeight";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "irr") {
        this.queryParams.orderFields = "irr";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "duration") {
        this.queryParams.orderFields = "duration";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "category") {
        this.queryParams.orderFields = "category";
        this.queryParams.orderWay = orderWay;
      }
      // xinzneg
      else if (data.property == "qs") {
        this.queryParams.orderFields = "qs";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "bearIrr") {
        this.queryParams.orderFields = "bearIrr";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "analyst") {
        this.queryParams.orderFields = "analyst";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "riskReward") {
        this.queryParams.orderFields = "riskReward";
        this.queryParams.orderWay = orderWay;
      } else if (data.property == "ticker") {
        this.queryParams.orderFields = "ticker";
        this.queryParams.orderWay = orderWay;
      }
      // xinznegjieshu
      else {
        return;
      }
      // debugger
      var order = "";
      if (data.order == null || data.order == "") {
        order = "ascending";
      } else if (data.order == "ascending") {
        order = "descending";
      } else {
        order = null;
      }
      // alert('' + JSON.stringify(order))
      this.$refs.tableList.sort(data.property, order);
      // if(this.queryParams.orderWay){
      //    this.queryParams.orderWay = asc
      // }
      this.getList();
    },
    changeViewVisible() {
      console.log(67687687687678);

      this.viewVisible = false;
      // location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.tableTop {
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  background: #f1f1f1;
  padding: 0 10px;
}

.tableTop .left {
}

.imageExcel {
  width: 30px;
  height: 30px;
}
</style>
<style>
.tablebox-el td,
.tablebox-el th {
  padding: 0px 0 !important;
}
</style>
